import { css } from "styled-components";

const InputHourWrapper = css`
`;


export default InputHourWrapper;
